<template>
    <b-col class="container-fluid">
        <b-col v-if="loading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
        </b-col>
        <div class="row mb-5 align-items-center" v-else-if="errorMessage && !loading">
            <div class="col-12">
                <div class="row border p-2 d-flex justify-content-center align-items-center">
                    <div class="d-flex flex-column align-items-center">
                        <i class="ri-information-line" style="font-size: 100px">
                        </i>
                        <p>
                            {{$t('api.'+errorMessage)}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <b-container class="mt-3">
                <b-row align-v="center" align-h="center" class="flex-column flex-md-row mt-2" style="gap: 3rem">
                    <b-col cols="12" md="auto" class="text-center">
                        <img src="@/assets/img/BAU_Logo.png" style="height: auto;width: 130px;" />

                    </b-col>
                    <b-col cols="12" md="auto" class="text-center">
                        <h3>{{ $t('course_agreement_form') }}</h3>
                    </b-col>
                    <b-col cols="12" md="auto" class="text-center">
                        <img src="@/assets/img/bau-logo-for-light.svg"/>
                    </b-col>
                </b-row>
            </b-container>
            <div class="row mb-4 align-items-center mt-4 p-4" v-if="data != null">
            <div class="col-12">
                <h6 class="mb-4  text-uppercase">{{ $t('student_information') }}</h6>

                <div class="row border p-3 g-3">
                    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <b-form-group :label="$t('student_number')">
                            {{ data.student_number }}
                        </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <b-form-group :label="$t('name_surname')">
                            {{ data.name }} {{ data.surname }}
                        </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <b-form-group :label="$t('class')">
                            {{ data.class}}
                        </b-form-group>
                    </div>

                    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <b-form-group :label="$t('program')">
                            {{ data.program }}
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
            <div v-if="slots != null" class="row p-4">
                <div class="overflow-x-auto">
                    <h6 class="mb-4 p-2 text-uppercase">{{ $t('courses') }}</h6>
                    <b-container class="mt-3">
                        <b-table
                            :items="slots"
                            :fields="fields"
                            bordered
                            responsive
                            hover
                            class="table table-bordered"
                        >
                            <template #thead-top>
                                <b-tr class="border">
                                    <b-th colspan="4" class="text-center">
                                        {{ $t('bahcesehir_university') }}
                                    </b-th>
                                    <b-th colspan="4" class="text-center">
                                        {{ $t('bay_atlantic_university') }}
                                    </b-th>
                                </b-tr>
                            </template>
                        </b-table>
                    </b-container>                </div>
            </div>
            <ValidationObserver ref="formValidate" >
                <b-col class="border p-3 d-flex flex-column  justify-content-center align-items-center" v-if="!hiddenButton">
                    <b-col md="4" xs="12">
                        <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('status')">
                                <multi-selectbox
                                    v-model="form.status" :multiple="false"
                                    :options="statusesOptions" :validate-error="errors[0]"
                                ></multi-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="4" xs="12" v-if="form.status==='wdc_declined'">
                        <ValidationProvider name="reason" :rules="form.status==='declined'?'required':''" v-slot="{ errors }">
                            <b-form-textarea
                                id="textarea"
                                v-model="form.reason"
                                :placeholder="$t('write_reason_for_rejection')"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>

                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </ValidationProvider>
                    </b-col>
                    <div  class="d-flex justify-content-center mt-3">
                        <b-button variant="primary" @click="save">{{
                                $t('save').toUpper()
                            }}
                        </b-button>
                    </div>
                </b-col>
            </ValidationObserver>
        </div>
    </b-col>
</template>
<script>
// Template
import CourseAgreementApprovedServices from "@/services/CourseAgreementApprovedServices";

export default {
    components: {
    },
    data() {
        return {
            fields: [
                {
                    key: 'course_code',
                    label: this.$t('course_code').toUpperCase(),
                    sortable: true,
                },
                {
                    key: 'course_name',
                    label: this.$t('course_name'),
                    sortable: true,
                    class: 'text-break', // Uzun metinler için kırılma
                },
                {
                    key: 'credit',
                    label: this.$t('credit').toUpperCase(),
                    sortable: true,
                },
                {
                    key: 'slot_type',
                    label: this.$t('slot_type').toUpperCase(),
                    sortable: true,
                },
                {
                    key: 'wdc_course_code',
                    label: this.$t('course_code').toUpperCase(),
                    sortable: true,
                },
                {
                    key: 'wdc_course_name',
                    label: this.$t('course_name').toUpperCase(),
                    sortable: true,
                    class: 'text-break',
                },
                {
                    key: 'wdc_credit',
                    label: this.$t('credit').toUpperCase(),
                    sortable: true,
                },
                {
                    key: 'wdc_slot_type',
                    label: this.$t('slot_type').toUpperCase(),
                    sortable: true,
                },
            ],
            data: null,
            slots: null,
            loading:false,
            errorMessage: null,
            hiddenButton: false,
            form:{},
            statusesOptions:[
                {
                    text:'Approved',value:'wdc_approved'
                },
                {
                    text:'Declined',value:'wdc_declined'
                }
            ]
        }
    },
    metaInfo() {
        return {
            title: this.$t("course_agreement_form"),
        }
    },
    watch:{
      'form.status'(val){
          if (val==='wdc_approved'){
              this.form.reason=null
          }
      }
    },
   beforeCreate(){
        this.$i18n.locale = 'en'
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData(){
            this.loading=true
            const config={
                token:this.$route.params.token
            }
            CourseAgreementApprovedServices.approveInformation(config)
                .then(response => {
                    this.data = response.data.data.student
                    this.slots = response.data.data.courses
                    this.loading=false
                }).catch(error => {
                    if (error.data.message==='UNAUTHORIZED'){
                        this.$router.push('/login')
                    }else {
                        this.errorMessage=error.data.message;
                        this.loading=false
                    }
            })
        },

        async save(){
            const isValid = await this.$refs.formValidate.validate()
            if (!isValid) return
            try {
                const config={
                     token:this.$route.params.token,
                     status:this.form.status,
                     reason:this.form.reason,
                }
                if (this.form.status==='wdc_approved'){
                    delete config.reason
                }
                const res =  await CourseAgreementApprovedServices.save(config)
                this.$toast.success(this.$t('api.' + res.data.message));
                this.hiddenButton=true

            }catch (error) {
                this.showErrors(error,this.$refs.formValidate)
            }
        },
    },
};
</script>
<style scoped>
</style>
